/**
 * /plantaofeo — LP fixa da ação Plantão FEO (URL sempre disponível).
 * Também é a página espelho de /pos quando a campanha "plantaofeo" está ativa.
 */
import { createFileRoute } from "@tanstack/react-router";
import { PlantaofeoPage } from "@/components/lps/PlantaofeoPage";
import { getAcoesStateFn } from "@/lib/campanhas/acoes.functions";

export const Route = createFileRoute("/plantaofeo")({
  head: () => ({
    meta: [
      { title: "Plantão FEO" },
      {
        name: "description",
        content:
          "Plantão FEO: pós-graduações da Fisio em Ortopedia com até 60% de desconto. Oferta por tempo limitado, o contador zera todo dia às 23h59.",
      },
      { property: "og:title", content: "Plantão FEO" },
      { property: "og:description", content: "Pós-graduações da FEO com até 60% de desconto. Oferta por tempo limitado." },
      { property: "og:url", content: "https://fisioemortopedia.com.br/plantaofeo" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Plantão FEO" },
      { name: "twitter:description", content: "Pós-graduações da FEO com até 60% de desconto." },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/plantaofeo" }],
  }),
  loader: () => getAcoesStateFn(),
  component: PlantaofeoRoute,
});

function PlantaofeoRoute() {
  const acoes = Route.useLoaderData();
  return <PlantaofeoPage ativa={Boolean(acoes?.plantaofeo?.ativa)} />;
}
